import { EnumOption } from '@shared/models/options.model';

export interface ExchangeToken {
  access_token: string;
  expires_in: number;
  token_type: string;
  first_access: boolean;
  user_password_expiration: UserPasswordExpiration;
}

export interface UserPasswordExpiration {
  message: string;
  status: EnumOption;
}

export enum PasswordExpirationStatus {
  VALID = 'VALID',
  EXPIRES_SOON = 'EXPIRES_SOON',
  EXPIRED = 'EXPIRED',
}
